import { Lang } from '@debbie/common/dist/lang/Lang.js';
import React from 'react';
import { useSelector } from 'react-redux';
import Select from './Select.js';
export const AllLanguagesInput = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Select, { portal: props.portal, disabled: props.disabled, label: lang.misc.language, title: lang.misc.language, searchPlaceholder: lang.misc.search, options: Object.keys(Lang)
            .sort((a, b) => lang.languages[a].localeCompare(lang.languages[b]))
            .map((l) => ({
            value: l,
            label: lang.languages[l],
        })), selected: props.language ? [props.language] : [], onChange: (selected) => {
            const value = selected[0];
            if (!props.disabled && props.onChange && value) {
                props.onChange(value);
            }
        } }));
};
export default AllLanguagesInput;
//# sourceMappingURL=AllLanguagesInput.js.map